var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	45675: {
		fallback: () => (__webpack_require__.e(5031).then(() => (() => (__webpack_require__(45031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	93586: {
		fallback: () => (__webpack_require__.e(7069).then(() => (() => (__webpack_require__(87069))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.20.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	},
	30886: {
		fallback: () => (__webpack_require__.e(7612).then(() => (() => (__webpack_require__(7612))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.10.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/hardware",
	},
	33755: {
		fallback: () => (__webpack_require__.e(3667).then(() => (() => (__webpack_require__(13667))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.7.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	47318: {
		fallback: () => (__webpack_require__.e(4143).then(() => (() => (__webpack_require__(24143))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.36.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "swagger-client",
	},
	49609: {
		fallback: () => (__webpack_require__.e(5914).then(() => (() => (__webpack_require__(83533))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.21.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/rbac",
	},
	53503: {
		fallback: () => (__webpack_require__.e(4965).then(() => (() => (__webpack_require__(74965))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.6.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	70306: {
		fallback: () => (__webpack_require__.e(2124).then(() => (() => (__webpack_require__(82124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "4.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	73834: {
		fallback: () => (__webpack_require__.e(1021).then(() => (() => (__webpack_require__(31021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	31518: {
		fallback: () => (Promise.all([__webpack_require__.e(1973), __webpack_require__.e(7186)]).then(() => (() => (__webpack_require__(29729))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.22.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "validatorjs",
	},
	40674: {
		fallback: () => (__webpack_require__.e(4353).then(() => (() => (__webpack_require__(74353))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.11.10",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",
	},
	40924: {
		fallback: () => (__webpack_require__.e(6799).then(() => (() => (__webpack_require__(76799))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-pdf-embed",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"423": [
		31518,
		40674,
		40924
	],
	"3586": [
		93586
	],
	"3743": [
		30886,
		33755,
		47318,
		49609,
		53503,
		70306,
		73834
	],
	"5675": [
		45675
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}